/**
 * <biosphere-show-more> — clamps a list on narrow screens, revealing the rest on
 * one press. Liquid renders every item and the button hidden; this hides the
 * overflow, so with no script the whole list stands.
 *
 * Clamped by viewport rather than always: the wide layout lays the same items
 * out in columns, where the length was never the problem.
 */
if (!customElements.get("biosphere-show-more")) {
  customElements.define(
    "biosphere-show-more",
    class BiosphereShowMore extends HTMLElement {
      #controller = new AbortController();
      #items = [];
      #button = null;
      #query = null;
      #expanded = false;

      connectedCallback() {
        this.#button = this.querySelector(".biosphere-show-more__button");
        const selector = this.dataset.itemSelector || "li";
        this.#items = [...this.querySelectorAll(selector)];

        const initial = Number(this.dataset.initial) || 6;
        if (!this.#button || this.#items.length <= initial) return;

        this.#query = matchMedia("(width <= 767px)");
        this.#query.addEventListener("change", () => this.#apply(initial), {
          signal: this.#controller.signal,
        });

        this.#button.addEventListener(
          "click",
          () => {
            this.#expanded = true;
            this.#apply(initial);
            this.#items[initial]?.querySelector("a, button")?.focus();
          },
          { signal: this.#controller.signal },
        );

        this.#apply(initial);
      }

      disconnectedCallback() {
        this.#controller.abort();
      }

      /** The clamp is the narrow layout's, and only until it has been opened. */
      #apply(initial) {
        const clamped = this.#query.matches && !this.#expanded;

        this.#items.forEach((item, index) => {
          item.hidden = clamped && index >= initial;
        });

        this.#button.hidden = !clamped;
      }
    },
  );
}
